import React, { useEffect, useState } from "react";
import { useFormContext } from 'react-hook-form'
import styles from './AnotherRentalsInputs.module.scss'
import cn from 'classnames';
import { Lang } from "../../../types/common-types";
import { State } from "../../../state-actions-reducers";
import AnotherRentalsItem from "../AnotherRentalItem/AnotherRentalItem";
import AddButton from "../../Buttons/AddButton";
import RadioInput from "../RadioInput/RadioInput";

interface AnotherRentalsInputsProps {
    lang: Lang
    accountForm: any
}
export default function AnotherRentalsInputs({ lang, accountForm }: AnotherRentalsInputsProps) {
    const { watch, setValue } = useFormContext<State>()
    const state = watch()

    const [rentalsCount, setRentalsCount] = useState(1)
    const rentals = () => {
        let list = []
        let lenght = rentalsCount;
        for (let i = 0; i < rentalsCount; i++) {
            list.push(
                <AnotherRentalsItem
                    key={`rental-${i}`}
                    lang={lang}
                    index={i}
                    disabled={false}
                    length={lenght}
                    deleteHandler={() => {
                        if (state.rentals?.[i]?.rentalName) {
                            setValue('rentals', state.rentals.filter((e, index) => index !== i) as any, { shouldDirty: true })
                        } else {
                            setRentalsCount(rentalsCount - 1)
                        }
                    }}
                />
            )
        }
        return list
    }
    const [initialization, setInitialization] = useState(false)
    useEffect(() => {
        (!initialization && state.rentals.length > 0) && setRentalsCount(state.rentals.length)
        setInitialization(true)
    }, [state.rentals])
    useEffect(() => {
        if (!state.rentalsCheck) setValue('rentals', [] as any, { shouldDirty: true })
    }, [state.rentalsCheck])
    console.log('state.rentals', state.rentals)
    return <div className="form-group">
        <div className="row">
            <div className={cn("col-12 col-xs-12", styles.rentalsTitle)}>
                <h3>{accountForm.stepTwoRentalsTitle[lang]}</h3>
            </div>
            <div className="col-4 col-xs-12">
                <div className={styles.rentalsCheckBox}>
                    <RadioInput name={'isAnotherRentalsYes'} lang={lang} label={accountForm.isAnotherRentalsYes} value={state.rentalsCheck} onChange={(e) => setValue('rentalsCheck', !state.rentalsCheck, { shouldDirty: true })} />
                    <RadioInput name={'isAnotherRentalsNo'} lang={lang} label={accountForm.isAnotherRentalsNo} value={!state.rentalsCheck} onChange={(e) => setValue('rentalsCheck', !state.rentalsCheck, { shouldDirty: true })} />
                </div>
            </div>
        </div>
        {state.rentalsCheck && <>
            {rentals()}
            <div className="row">
                <div className="col-12 col-xs-12">
                    {state.rentals.length < 6 && (
                        <div
                            className={styles.addButtonBox}
                            onClick={() => {
                                setRentalsCount(rentalsCount + 1);
                                setValue('rentals', [
                                    ...state.rentals,
                                    {
                                        rentalName: "",
                                        rentalDiscount: "",
                                        rentalDataFile: {},
                                    },
                                ] as any, { shouldDirty: true })
                            }}
                        >
                            <AddButton />
                            <span>{accountForm.rentalsButton[lang]}</span>
                        </div>
                    )}
                </div>
            </div>
        </>}
    </div>
}
